"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOGGLE_POPUP = void 0;
exports.TOGGLE_POPUP = 'TOGGLE_POPUP';
